module.exports = __webpack_public_path__ + "static/media/award-2-02.dfc25ab1.svg";